import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";

// Helpful resources for setting up i18next in a React app:
// https://phrase.com/blog/posts/localizing-react-apps-with-i18next/
// https://medium.com/@xbstrxct/localization-in-react-best-practices-e38dee708aae

i18n
  .use(HttpBackend) // Load translations from JSON files
  .use(LanguageDetector) // Detect browser language
  .use(initReactI18next) // Bind with React
  .init({
    fallbackLng: "en", // Default language
    supportedLngs: ["en", "es", "fr"], // supported languages
    debug: true,
    interpolation: {
      escapeValue: false, // React already handles escaping
    },
  });

export default i18n;